/* eslint-disable */
<template>
  <div>
    <div class="table">
      <div class="row">
        <div class="col">
          <h1 v-if="displayTitle">{{ title }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="mainImage">
            <img ref="mainImage" :src="this.getCabinSrc()" />
          </div>
          <div>
            <div class="carousel">
              <carousel-3d @after-slide-change="onAfterSlideChange">
                <slide v-for="(slide, i) in slides" :index="i" :key="i">
                  <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
                    <img
                      :data-index="index"
                      :class="{ current: isCurrent, onLeft: leftIndex >= 0, onRight: rightIndex >= 0 }"
                      style="max-height: 200px; object-fit: contain;"
                      :src="slide.src"
                    />
                  </template>
                </slide>
              </carousel-3d>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="myDiv" v-html="description"></div>
        </div>
      </div>
      <div class="row">
        <div class="col" width="100%">
          <br />
          <b-button v-if="displayVrbo" pill :href="vrboUrl">Book/Availability</b-button>
          <a class="facebook" v-if="displayFaceBook" :href="facebookUrl"><img alt="Facebook" title="Follow Us" src="../../assets/social-facebook-button-blue-icon.png" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<link rel="stylesheet" href="vue-sidebar-menu/dist/vue-sidebar-menu.css" />
<link rel="stylesheet" href="vue-ical-calendar/dist/vue-ical-calendar.css" />

<script>
import { Carousel3d, Slide } from 'vue-carousel-3d';

export default {
  props: ['title', 'calendarData', 'description', 'slides', 'imgDir', 'facebookUrl', 'vrboUrl'],
  components: {
    Carousel3d,
    Slide
  },
  computed: {
    displayTitle() {
      return this.title.length > 0;
    },
    displayFaceBook() {
      return this.facebookUrl !== '';
    },
    displayVrbo() {
      return this.vrboUrl !== '';
    }
  },
  methods: {
    onAfterSlideChange(index) {
      this.$refs.mainImage.src = this.slides[index].src;
    },
    getCabinSrc() {
      return this.slides.find((k) => k.name === './Cabin.jpg').src;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.facebook img {
  height: 40px;
  width: 40px;
  object-fit: scale-down;
}
.mainImage img {
  height: 400px;
  width: 400px;
  object-fit: scale-down;
}
.carousel img {
  height: 100%;
  object-fit: scale-down;
}
p {
  margin-left: 10px;
}
.myDiv {
  background-color: lightgray;
  height: 100%;
  margin-left: 5%;
  margin-right: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Cabin.vue